import { extractErrorMessages } from '@fukuri-admins/ui/common/Form/logics/extractErrorMessages';
import React, { ComponentProps } from 'react';
import { useController, useFormContext } from 'react-hook-form';
import { TextAreaField } from '..';

type TextAreaFieldProps = ComponentProps<typeof TextAreaField>;

type Props = {
  name: string;
  textArea?: TextAreaFieldProps['textArea'];
  fieldWrapperProps: Omit<TextAreaFieldProps['fieldWrapperProps'], 'htmlFor' | 'errorMessages'>;
};

export const TextAreaFieldController: React.FC<Props> = ({ name, fieldWrapperProps, textArea }) => {
  const { control } = useFormContext();

  const {
    field: { ref, ...restField },
    fieldState: { error },
  } = useController({ control, name });

  return (
    <TextAreaField
      fieldWrapperProps={{
        htmlFor: name,
        errorMessages: extractErrorMessages(error),
        ...fieldWrapperProps,
      }}
      textArea={{ ...textArea, error: !!error }}
      {...restField}
    />
  );
};
